import {Component, OnInit, Input} from '@angular/core';
import {IsFilterOnService} from '../../../../Services/is-filter-on.service';

@Component({
  selector: 'app-reporting-field-select',
  templateUrl: './reporting-field-select.component.html',
  styleUrls: ['./reporting-field-select.component.css'],
  standalone: false
})
export class ReportingFieldSelectComponent implements OnInit {
  @Input() vm: any;

  // cache detected offset (0 for rf1-based, 1 for rf0-based datasets)
  private __rfIndexOffset: number | null = null;

  constructor(public isFiltered: IsFilterOnService) {
  }

  ngOnInit() {
  }

  checkFiltered(): boolean {
    const filteredValue = this.isFiltered.isFiltered(this.vm);
    this.vm.filtered = filteredValue;
    return filteredValue;
  }

  // Detect if the dataset uses zero-based rf codes (rf0..rf4) and compute offset accordingly
  private getRfIndexOffset(): number {
    if (this.__rfIndexOffset != null) {
      return this.__rfIndexOffset;
    }
    try {
      const types: any[] = (this.vm?.rfTypeOrdered && this.vm.rfTypeOrdered.length)
        ? this.vm.rfTypeOrdered
        : (Array.isArray(this.vm?.rfType) ? this.vm.rfType : []);
      let min = Number.POSITIVE_INFINITY;
      for (const t of types) {
        const code = String(t?.code ?? '').toLowerCase();
        const m = code.match(/^rf(\d+)$/);
        if (m && m[1]) {
          const n = Number(m[1]);
          if (!Number.isNaN(n)) {
            min = Math.min(min, n);
          }
        }
      }
      // If the smallest index we see is 0, assume zero-based and shift by +1 to map to rf_id_1..5
      this.__rfIndexOffset = (min === 0) ? 1 : 0;
    } catch {
      this.__rfIndexOffset = 0;
    }
    return this.__rfIndexOffset;
  }

  // Determine the request key (rf_id_1..rf_id_5) from a reporting_field_type record
  requestKeyForType(type: any): string {
    const offset = this.getRfIndexOffset();
    const code = String(type?.code ?? '').toLowerCase();
    const m = code.match(/rf(\d+)/);
    if (m && m[1]) {
      const n = Number(m[1]);
      const idx = !Number.isNaN(n) ? (n + offset) : null;
      if (idx != null) {
        return `rf_id_${idx}`;
      }
    }
    // Fallback: if code is missing/unexpected, try name, else default to rf_id_1 to avoid crash
    const name = String(type?.name ?? '').toLowerCase();
    const m2 = name.match(/rf(\d+)/);
    if (m2 && m2[1]) {
      const n = Number(m2[1]);
      const idx = !Number.isNaN(n) ? (n + offset) : null;
      if (idx != null) {
        return `rf_id_${idx}`;
      }
    }
    return 'rf_id_1';
  }

  // Get the list of reporting_field items for a given reporting_field_type id
  fieldsForTypeId(typeId: any): any[] {
    const byType = this.vm?.rfByTypeId || {};
    const key = String(typeId ?? '');
    return Array.isArray(byType[key]) ? byType[key] : [];
  }

  // Safe renderer for option label
  formatFieldLabel(f: any): string {
    const code = f?.code ?? '';
    const name = f?.name ?? '';
    return `${code} • ${name}`.trim();
  }
}
